import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { StatusLevel } from '../controls/types'

// `ok` is neutral by default — only callers that read as a traffic light (colorOk) paint it green.
export const levelModifier = (level: StatusLevel, colorOk = false): string => {
  if (level === 'warn' || level === 'error' || level === 'neutral') return level

  return colorOk && level === 'ok' ? 'ok' : ''
}

export const classFor = (base: string, modifier: string): string => (modifier ? `${base} ${base}--${modifier}` : base)

interface Props {
  label: string
  level: StatusLevel
  detail?: string
  size?: 'sm'
  colorOk?: boolean
}

const StatusIndicatorBadge = ({ label, level, detail, size, colorOk }: Props) => {
  const className = [
    classFor('control-status-bar__indicator', levelModifier(level, colorOk)),
    size === 'sm' ? 'control-status-bar__indicator--sm' : '',
  ].filter(Boolean).join(' ')

  const body = <span className={className}>{label}</span>

  if (!detail) return body

  return (
    <Tooltip title={detail} placement="top" arrow>
      {body}
    </Tooltip>
  )
}

export default StatusIndicatorBadge
